// @TODO <HEALTH2019>
App.controller('HealthInsuranceWithPaymentsListCtrl', ['$scope', '$stateParams', '$sce', '$state', '$http', '$mdDialog', 'Config', 'insuranceService', 'profileService', '$timeout', 'FileSaver', 'Blob', '$rootScope', 'healthInsuranceService', 'moment', 'wireTransferService', '$filter', function ($scope, $stateParams, $sce, $state, $http, $mdDialog, Config, insuranceService, profileService, $timeout, FileSaver, Blob, $rootScope, healthInsuranceService, moment, wireTransferService, $filter) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.page = 'mypackage';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Opieka medyczna (LUX MED)';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

// @TODO <HEALTH2019>
    function checkIfUserHasActiveDeclaration(){
        if($scope.userData && $scope.package){
            if ($scope.package.status === 'ENTERED') {
                $scope.status = 'Oczekiwanie na wpłatę';
            } else if ($scope.package.status === 'READY') {
                $scope.status = 'Pakiet opłacony – aktywacja od ' + $scope.package.proposedDate;
            } else if ($scope.package.status === 'ACTIVE') {
                $scope.status = 'Pakiet aktywny od ' + moment(new Date($scope.package.activeDate)).format('YYYY-MM-DD');
            } else if ($scope.package.status === 'WITHDRAWN') {
                $scope.status = 'Zakończenie pakietu z dniem ' + moment(new Date($scope.package.endDateBasedOnWithdrawalDate)).format('YYYY-MM-DD');
            } else if ($scope.package.status === 'ENDED') {
                $scope.status = 'Pakiet zakończony z dniem ' + moment(new Date($scope.package.endedDate)).format('YYYY-MM-DD');
            } else {
                $scope.status = 'Pakiet czeka na aktywację';
            }
            if ($scope.package.payedToDate) {
                $scope.payedToDate = moment(new Date($scope.package.payedToDate)).format('YYYY-MM-DD');
            }

            $scope.userData.hasActiveDeclaration = $scope.package.status === 'ACTIVE';
            $scope.userData.isAfterSixMonth = false;
            if ($scope.userData.hasActiveDeclaration && $scope.package.activeDate) {
                var _activeDate = new Date($scope.package.activeDate);
                _activeDate.setMonth(_activeDate.getMonth() + 5);

                var now = new Date();
                if (now.getTime() >= _activeDate.getTime()) {
                    $scope.userData.isAfterSixMonth = true;
                }
            }
        }
    }

    $scope.package = null;
    healthInsuranceService.getLastDeclaration('LUXMED').then(function (data) {
        if (data.status === 200) {
            var pkg = data.data;

            if (!pkg || !Object.keys(pkg).length) {
                $state.go('root.home.healthInsuranceWithPayments.package');
                return;
            }
            $scope.package = pkg;
            if (typeof $scope.package.rehabilitation !== 'undefined' && $scope.package.rehabilitation) {
                $scope.package.benefit.name += ' + Rehabilitacja';
                $scope.package.benefit.summaryPrice += $scope.package.benefit.rehabilitationPrice;
                $scope.package.benefit.workerPrice += $scope.package.benefit.rehabilitationPrice;
            }
            checkIfUserHasActiveDeclaration();

        }
    });
// @TODO </HEALTH2019>
    profileService.dataUser().then(function (data) {
// @TODO <HEALTH2019>
        $scope.userData = data.data;
        checkIfUserHasActiveDeclaration();
// @TODO </HEALTH2019>
    });

    $scope.bankAccountNumber = null;
    $scope.paymentsBalance = null;
    profileService.getBankAccountNumber('HEALTH_INSURANCE').then(function (success) {
        if(success.status === 200 && success.data){
            $scope.bankAccountNumber = success.data['accountNumber'];
            profileService.getBankAccountBalance('HEALTH_INSURANCE').then(function (success) {
                if (success.status === 200 && success.data) {
                    let balance = success.data.balance;
                    if (balance) {
                        $scope.paymentsBalance = $filter('floatCurrencyFormatter')(balance);
                    }
                }
            });
        }
    });

    $scope.current = 0;
    $scope.numberOfPages = 1;
    $scope.searchString = '';

    loadActivities($scope.current);

    $scope.payments = [];
    $scope.paymentsCurrent = 0;
    $scope.paymentsNumberOfPages = 1;
    $scope.paymentsPageSize = 10;

    loadPayments($scope.current);

    function loadActivities(page) {
    	var criteria = {
            pageNumber: page,
            pageSize: 10,
            searchString: $scope.searchString,
            insurer: 'LUXMED'
        };
// @TODO <HEALTH2019>
            healthInsuranceService.getDeclarations(criteria).then(function (data) {
                if (data.status === 200) {
                    angular.forEach(data.data.data, function (single) {
                        single.numberOfRelatives = (single.partner ? 1 : 0) + single.children.length;
                    });
                    $scope.activities = data.data.data;
                    $scope.numberOfPages = data.data.pages;
                    // $scope.buildScroll();
                    // console.log($scope.activities);
                }
            });
	}
// @TODO </HEALTH2019>

    function loadPayments(page) {
        var params = {
            pageNumber: page,
            pageSize: $scope.paymentsPageSize,
            insuranceProject: 'HEALTH_INSURANCE'
        }
        wireTransferService.getPayments(params).then(function (data) {
            if (data.status === 200) {
                $scope.payments = data.data.data;
                $scope.paymentsNumberOfPages = data.data.pages;
            }
        })
    }

	$scope.search = function () {
        loadActivities(0);
    };

    $scope.pageChanged = function (page) {
        loadActivities(page);
        $scope.current = page;
    };

    $scope.paymentsPageChanged = function (page) {
        loadPayments(page);
        $scope.paymentsCurrent = page;
    };

    $scope.viewDeclaration = function(declaration) {
        $state.go('root.home.healthInsuranceWithPayments.details', {package: declaration});
    }

    $scope.addProteges = function () {
    	if ($scope.userData.benefit.partner || $scope.userData.benefit.children) {
    		$state.go('root.home.profile_proteges.lists');
    	} else {
    		$scope.showPopUp('', 'Rozszerz pakiet!', 'Twój pakiet nie obejmuje opieki dla podopiecznych, rozszerzy pakiet aby dodać członków rodziny.', 'Przejdź do wyboru pakietu', 'root.home.healthInsuranceWithPayments.package', 'true');
    	}
    }

    $scope.showPopUp = function(ev, head, content, text, target, exit) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {

        }, function() {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.buildScroll = function() {
        $timeout(function() {
            scrollbarHorizontalMenu('.activitylist .scroll');
        }, 1);
    }

    function scrollbarHorizontalMenu(el) {
        $(el).mCustomScrollbar({
            axis:"x",
            theme:"dark-thin",
            autoHideScrollbar: true,
            scrollbarPosition: "outside",
            advanced:{autoExpandHorizontalScroll:true},
            callbacks:{
                onInit: function(){

                },
                onScroll: function(){

                }
            }
        });
    }
// @TODO <HEALTH2019>
    $scope.getDeclaration = function(ev, value) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        var id = value.uuid, barcode = value.barcode || '';

        healthInsuranceService.getDeclaration(id).then(function (data) {
            if (data.status === 200) {
                let blob = new Blob([data.data], {type: 'application/pdf'});
                FileSaver.saveAs(blob, 'Deklaracja_' + barcode + '.pdf');
            }

            $timeout(function () {
                $(ev.currentTarget).removeClass('disabled');
            }, 1500);
        });
    }
// @TODO </HEALTH2019>

    $scope.getStatement = function(ev, id) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
// @TODO <HEALTH2019>
            healthInsuranceService.getStatement(id).then(function (data) {
                if (data.status === 200) {
                    let blob = new Blob([data.data], { type: 'application/pdf' });
                    FileSaver.saveAs(blob, 'oświadczenie.pdf');
                }

                $timeout(function() {
                    $(ev.currentTarget).removeClass('disabled');
                }, 1500);
            });
// @TODO </HEALTH2019>
        }

}]);
